<template>
     <v-dialog v-model="uploadFile" width="900" scrollable>
    <v-card>
      <v-card-title class="headline grey lighten-2">
        Upload file
      </v-card-title>
      <v-card-text style>
         <div class="col-sm-12 row ml-0 pa-0">
      <CCol sm="12" md="6">
        <label for>Title</label>
        <div >
          <input 
            class="form-control" 
            placeholder="Title" 
            v-model="adminDocData.title"
            @keydown.space="preventEmptySpace"
            type="text"
          />
          <span
            v-if="adminDocData.title === '' && alert === true"
            class="text-danger required-fields"
          >{{ requiredAlert }}</span>
        </div>
      </CCol>
       <CCol sm="12" md="6">
        <label for>Upload file <span class="p-clr">(You can upload only PDF)</span></label>
          <file-upload
            :media="reportMedia"
            label="upload"
            :refName="'upload1Qual'"
            :certificate_type="'admin'"
            :multiple="false"
            :drop="true"
            :isPublicUpload="true"
            :module="'admin'"
            :role="'admin'"
            :accept="accepted"
            :src="proofPreview"
            @removeImage="removePicture"
            @uploaded="fileUploaded"
            @imageRemoved="imageRemoved"
            :uploadFileToServer="uploadProof"
          ></file-upload>
          <span
            v-if="adminDocData.attachment === '' && alert === true"
            class="text-danger required-fields"
          >{{ requiredAlert }}</span>
       </CCol>
        <CCol sm="12" class="flex-end">
        <v-checkbox  
          class="checkBox-stye mt-0" 
          hide-details 
          :label="`Share and download allowed`"
          v-model="sharableAndDownloadable"
        ></v-checkbox>
        </CCol>
         </div>
      </v-card-text>
       <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="closeModal()">Cancel</v-btn>
        <v-btn  color="success" class="mr-4" @click="validateBeforeSubmit()">Save</v-btn>
      </v-card-actions>
    </v-card>
     </v-dialog>
</template>
<script>
import Swal from "sweetalert2";
import config from "@/config.js";
import FileUpload from "@/components/FileUploadNew.vue";
export default {
    props: [ "uploadDocumentFile", "updateObject"],
    data() {
      return {
        accepted: "application/pdf",
        docLink: this.updateObject && this.updateObject.attachment ? this.updateObject.attachment : null,
        showLoader: false,
        uploadToServer: false,
        uploadedImg: [],
        uploadedImgFullUrl: [],
        uploadFile: this.uploadDocumentFile,
        adminDocData: this.updateObject,
        alert: false,
        requiredAlert: "This field is required.",
        sharableAndDownloadable: this.updateObject && this.updateObject.permissions && this.updateObject.permissions.is_downloadable ? this.updateObject.permissions.is_downloadable : false,
        proofPreview: this.updateObject && this.updateObject.attachment ? this.updateObject.attachment : null,
        uploadProof: true,
        reportMedia: "application/pdf"
      }
    },
    components:{
        FileUpload
    },
    methods:{
      closeModal() {
        this.adminDocData.title = "";
        this.adminDocData.attachment = "";
        this.proofPreview = null;
        this.uploadedImg = [];
        this.uploadedImgFullUrl = [];
        this.alert = false;
        this.$emit("close");
      },
      removePicture(list) {
        this.proofPreview = null;
      },
      fileUploaded(files, uploaded, name, size, pdfFileName) {
        this.adminDocData.file_size = size;
        this.adminDocData.file_name = pdfFileName;
        this.showLoader = true;
        if (uploaded) {
          this.proofUploaded = true;
          this.adminDocData.attachment = files[0]
        } else if (files.length) {
          this.reportMedia = files[0].type;
          this.proofPreview = files[0].blob;
        } else {
          this.proofPreview = null;
        }
      },
      imageRemoved() {
        this.adminDocData.attachment = ""
      },
      preventEmptySpace(e) {
        if (!e.target.value) e.preventDefault();
        else if (e.target.value[0] == " ")
          e.target.value = e.target.value.replace(/^\s*/, "");
      },
      validateBeforeSubmit() {
        this.alert = true;
        if (!this.adminDocData.to_update && this.adminDocData.title && this.adminDocData.attachment)
          this.createAdminDocumnet()

        else if (this.adminDocData.to_update && this.adminDocData.title && this.adminDocData.attachment)
          this.updateAdminDocumnet(this.adminDocData)
      },
      createAdminDocumnet() {
        let obj = {
          title: this.adminDocData.title,
          attachment: this.adminDocData.attachment,
          attachment_type: "pdf",
          file_size: this.adminDocData.file_size,
          file_name: this.adminDocData.file_name
        };
        if (this.sharableAndDownloadable){
          obj.permissions = {
            is_downloadable : true,
            is_sharable : true
          }
        }
        let url = `${config.BASE_URL}api/v2/admin/create-admin-document`;
        this.$http.post(url, obj).then(response => {
          if (!!response.ok) {
            Swal.fire({
              title: "Admin Document Updated Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("close");
              }
            });
          }
        });
      },
      updateAdminDocumnet(updateObject) {
        let obj = {
          title: this.adminDocData.title,
          attachment: this.adminDocData.attachment,
          attachment_type: "pdf",
          file_size: this.adminDocData.file_size,
          file_name: this.adminDocData.file_name
        };
        if (updateObject._id){
          obj._id = updateObject._id
        }
        if (this.sharableAndDownloadable){
          obj.permissions = {
            is_downloadable : true,
            is_sharable : true
          }
        } else {
          obj.permissions = {
            is_downloadable : false,
            is_sharable : false
          }
        }
        let url = `${config.BASE_URL}api/v2/admin/update-admin-document`;
        this.$http.put(url, obj).then(response => {
          if (!!response.ok) {
            Swal.fire({
              title: "Admin Document Updated Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("close");
              }
            });
          }
        });
      },
    }   
}
</script>